import { render } from "./TipoProductos.vue?vue&type=template&id=49ef6dae"
import script from "./TipoProductos.vue?vue&type=script&lang=js"
export * from "./TipoProductos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__